import React, { useState, Suspense, createElement } from 'react';
import { Link } from 'react-router-dom';
import { Menu, LogOut } from 'lucide-react';
import { motion } from 'framer-motion';
import { AINewsNarrator } from './AINewsNarrator';
import { MobileMenu } from './MobileMenu';
import { useAuth } from '../hooks/useAuth';
export function Header() {
  const {
    user,
    signInWithGoogle,
    signOut
  } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [isDonateModalOpen, setIsDonateModalOpen] = useState(false);
  return <>
      <header className="fixed top-0 left-0 right-0 z-40 border-b border-white/5 bg-black backdrop-blur-xl" data-id="element-323">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between gap-8" data-id="element-324">
          {/* Logo - Text with gradient on AI */}
          <Link to="/" className="flex items-center shrink-0" data-id="element-325">
            <span style={{
            fontFamily: 'Space Grotesk, sans-serif',
            fontWeight: 300,
            fontSize: '1.125rem',
            lineHeight: '1.75rem',
            letterSpacing: '.15em'
          }} className="text-white" data-id="element-326">
              FAIND
            </span>
          </Link>

          {/* AI News - Centered */}
          <div className="absolute left-1/2 -translate-x-1/2 hidden md:block" data-id="element-327">
            <AINewsNarrator data-id="element-328" />
          </div>

          {/* Right side */}
          <div className="flex items-center gap-3 shrink-0 ml-auto" data-id="element-329">
            {/* Sign in button (only if not logged in) */}
            {!user && <button onClick={signInWithGoogle} className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 text-white hover:bg-white/20 transition-all text-sm font-medium" data-id="element-330">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-331">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-332" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-333" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-334" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-335" />
                </svg>
                <span data-id="element-336">Sign in</span>
              </button>}

            {/* User button with logout (only if logged in) */}
            {user && <motion.button onClick={signOut} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="flex items-center gap-2 px-3 py-2 rounded-full bg-white/10 border border-white/10 text-white hover:bg-white/20 transition-all" data-id="element-337">
                <img src={user.user_metadata?.avatar_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${user.email}`} alt="Profile" className="w-6 h-6 rounded-full" data-id="element-338" />
                <span className="text-sm font-medium hidden sm:inline" data-id="element-339">
                  {user.email?.split('@')[0]}
                </span>
                <LogOut size={14} className="text-white/60" data-id="element-340" />
              </motion.button>}

            {/* Burger Menu Button */}
            <button onClick={() => setIsMenuOpen(true)} className="p-2 text-white hover:text-white/80 transition-colors" data-id="element-341">
              <Menu size={20} data-id="element-342" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} onSubmitTool={() => setIsSubmitModalOpen(true)} onDonate={() => setIsDonateModalOpen(true)} data-id="element-343" />

      {/* Modals - Lazy load to avoid circular dependencies */}
      {isSubmitModalOpen && <Suspense fallback={null} data-id="element-344">
          {createElement(require('./SubmitToolModal').SubmitToolModal, {
        isOpen: isSubmitModalOpen,
        onClose: () => setIsSubmitModalOpen(false)
      })}
        </Suspense>}

      {isDonateModalOpen && <Suspense fallback={null} data-id="element-345">
          {createElement(require('./DonateModal').DonateModal, {
        isOpen: isDonateModalOpen,
        onClose: () => setIsDonateModalOpen(false)
      })}
        </Suspense>}
    </>;
}